import styled from "styled-components";
import { Font, Color, breakpoints, ColorDark } from "@/shared/Constants";

export const ImageContainer = styled.div.attrs((props) => ({
  className: props.className,
}))`
 
`;

export const StoryMainImage = styled.picture.attrs((props) => ({
  className: props.className,
}))`
  height: auto;
  overflow: hidden;
  cursor: pointer;
  margin-bottom: 1rem;
  margin: 17px 0;
  position: relative;
  display: block;

  ${breakpoints.phone} {
      width: 98vw;
      left: 50%;
      transform: translateX(-50.16%);
    }

  source {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  img {
    object-fit: cover;
    display: flex;
    margin: auto;
  }
  .epigraphe {
    ${Font.sansRegular};
    font-size: 14px;
    line-height: 17px;
    color: ${Color.black000};
    margin-top: 12px;
    display: block;
    width: 100%;
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        color: ${ColorDark.textLight};
      }
    }   
    ${breakpoints.phone} {        
        padding: 1px 19px 5px;
      }
  }
`;
